import { createLogger, loggerStyles } from '@ricoh/ria.client.core/plugins/app/logger';

import { addEvent } from './_event';

const logger = createLogger('app/dom');

/** DOM plugin. */
const domPlugin = {
  /** Init DOM plugin. */
  init: () => {
    addEvent();

    logger.write('info', `${loggerStyles.responseText('Init')} DOM`);
  },
};

export default domPlugin;
